import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { IonButton, IonPage, IonHeader, IonIcon, IonToolbar, IonTitle, IonContent, modalController } from '@ionic/vue'
import PerformerCard from '@/components/PerformerCard.vue'
import { addCircleOutline } from 'ionicons/icons'

import { ref } from 'vue'
import { useEventStore } from '@/store/event'


export default /*#__PURE__*/_defineComponent({
  __name: 'EventPerformersTab',
  setup(__props) {

const $store = useEventStore()

const openedPerformerCard = ref('')
function toggleCard(id = '') {
  openedPerformerCard.value = openedPerformerCard.value === id ? '' : id
}

async function createPerformer () {
  const PerformerForm = await import('@/components/PerformerForm.vue')
  return (await modalController.create({
    component: PerformerForm.default,
    ...PerformerForm.modalOptions
  })).present()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), {
        collapse: "fade",
        translucent: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode("Účinkující")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), { fullscreen: "" }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonHeader), { collapse: "condense" }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonToolbar), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonTitle), { size: "large" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Účinkující")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref($store).performers, (item) => {
            return (_openBlock(), _createBlock(PerformerCard, {
              key: item.id,
              item: item,
              opened: openedPerformerCard.value === item.id,
              onHeaderClicked: ($event: any) => (toggleCard(item.id))
            }, null, 8, ["item", "opened", "onHeaderClicked"]))
          }), 128)),
          (_unref($store).currentMember?.canWrite)
            ? (_openBlock(), _createBlock(_unref(IonButton), {
                key: 0,
                expand: "full",
                fill: "clear",
                class: "ion-margin-top",
                onClick: createPerformer
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonIcon), {
                    slot: "icon-only",
                    icon: _unref(addCircleOutline)
                  }, null, 8, ["icon"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})